import { AAHASearchUrl } from '@/lib/constants';
import { SearchResultsProps } from './SearchResult';

export default function SearchResultFooter({ result }: SearchResultsProps) {
  const serialNumber = result.chip.serialNumber;
  const externalRegistriesSearchUrl = AAHASearchUrl(serialNumber);

  return (
    <div style={{ textAlign: 'center', padding: '0 20px' }}>
      {result && result.pet && (
        <p>
          <span style={{ fontWeight: '500' }}>Note:</span> While Fi attempts to ensure we have the latest contact
          information, chip details may have been updated more recently in another registry.{' '}
          <a href={externalRegistriesSearchUrl} target="_blank">
            Check other registries{' '}
            <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 19H5V5H12V3H3V21H21V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"></path>
            </svg>
          </a>
        </p>
      )}
      Please contact Fi at <a href="tel:18556266817">1-855-626-6817</a> from 10 AM to 8 PM EST if you are experiencing
      any issues.
    </div>
  );
}
